var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"allSettingItem",class:_vm.customClass,attrs:{"to":{ name: _vm.toName }}},[_c('div',{staticClass:"icon"},[_c('BaseIcon',{attrs:{"icon":_vm.icon}})],1),_c('span',{staticClass:"text f16"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }